import { camundaApi } from "@/core/api/camundaApi";
import { pushVirtualPageView as pushHotjarVirtualPageView } from "@/core/lib/hotjar/hotjar";
import { SIGNATURE_EVENT } from "@/core/data";
import { pushVirtualPageView as pushGtmVirtualPageView } from "@/core/lib/gtm/gtm";
import { pushVirtualPageView as pushDataDogVirtualPageView } from "@/core/lib/datadog/datadog";
import {
  hasEventBeenTriggered,
  pushEventTriggeredSignal,
} from "@/core/utils/eventsToExpose/eventUtils";
import { EventCallbackData } from "@/core/utils/eventsToExpose/getEventToExposeCallback";

const SIGNATURE_EVENT_SIGNAL: string = "signatureEventTriggered";

const pushSignatureEvent = async ({
  definitionName,
  domain,
}: EventCallbackData) => {
  const signatureEventTriggered = await hasEventBeenTriggered(
    SIGNATURE_EVENT_SIGNAL
  );
  if (signatureEventTriggered) {
    return;
  }
  const signatureComponentResult = await camundaApi.getVariablesForProcess([
    "signatureComponent",
  ]);
  const {
    data: { signatureComponent },
  } = signatureComponentResult;
  if (signatureComponent) {
    pushHotjarVirtualPageView(SIGNATURE_EVENT);
    pushGtmVirtualPageView(SIGNATURE_EVENT, definitionName);
    pushDataDogVirtualPageView(SIGNATURE_EVENT, definitionName, domain ?? "");

    pushEventTriggeredSignal("signatureEventTriggered");
  }
};

export default pushSignatureEvent;
